export default {
  // request_url:'/api/web',
  request_url:'http://tj.cjnep.net',
  // request_url:'http://10.82.96.169:8090',
}



//////////////////
// WEBPACK FOOTER
// ./static/conf.js
// module id = null
// module chunks = 